import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { JSONUtils } from '../utils/JSONUtils';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class LocalService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}
  key = 'test';

  public saveData(key: string, value: string) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(key, this.encrypt(value));
      return;
    }
    return null;
  }

  public getData(key: string) {
    if (isPlatformBrowser(this.platformId)) {
      let data = localStorage.getItem(key) || '';
      return JSONUtils.parse(this.decrypt(data));
    }
    return null;
  }
  public removeData(key: string) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem(key);
      return;
    }
  }

  public clearData() {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.clear();
    }
  }

  private encrypt(txt: string): string {
    return CryptoJS.AES.encrypt(txt, this.key).toString();
  }

  private decrypt(txtToDecrypt: string) {
    return CryptoJS.AES.decrypt(txtToDecrypt, this.key).toString(
      CryptoJS.enc.Utf8
    );
  }
}
